module.exports = "./img/348feadf475cfbd4a20ff0a205d49669.jpg";